import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { sendBookingFormData } from '@shared/services/services';
import CloseIcon from '@mui/icons-material/Close';
import StyledTextField from '@shared/components/StyledTextField';

export const registerHotelFormSchema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  phone: Yup.string()
    .required('Campo requerido')
    .matches('^[0-9]+$', 'Este campo solo acepta numeros'),
  email: Yup.string()
    .required('Campo requerido')
    .email('Ingrese un email valido'),
});

const FormCheckAvailavility = ({ closeModalHandler, showMessage }) => {
  const { city, checkIn, checkOut, totalPassengers } = useSelector(
    state => state.search
  );

  const { hotelDetails } = useSelector(state => state.hotelDetail);

  const formik = useFormik({
    initialValues: {
      name: '',
      phone: '',
      email: '',
    },
    validationSchema: registerHotelFormSchema,
    onSubmit: async values => {
      try {
        await sendBookingFormData({
          name: values.name,
          phone: values.phone,
          email: values.email,
          establishment_name: hotelDetails.name,
          total_passengers: totalPassengers,
          check_in: checkIn,
          check_out: checkOut,
          city_name: city.label,
        });
        showMessage(true);
        closeModalHandler(false);
      } catch (error) {
        console.error('Error', error);
      }
    },
  });

  return (
    <>
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12} style={{ display: 'flex', paddingLeft: '0px' }}>
          <Typography
            variant="h5"
            color="initial"
            align="center"
            style={{ color: '#000000', marginTop: '20px', fontSize: '20px' }}
          >
            Bienvenido a la plataforma de venta de alojamiento mas exitosa de la
            región
          </Typography>
          <Grid
            item
            xs={6}
            style={{ position: 'absolute', display: 'contents' }}
          >
            <CloseIcon
              onClick={() => closeModalHandler(false)}
              fontSize="medium"
              style={{
                position: 'relative',
                color: '#000000',
                cursor: 'pointer',
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingLeft: '0px' }}>
          <Typography
            variant="h5"
            color="initial"
            align="left"
            style={{ color: '#000000', fontSize: '15px', marginBottom: '10px' }}
          >
            Sentimos que no haya disponibilidad en estos momentos, por favor
            ingrese su consulta
          </Typography>
        </Grid>
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid item xs={12} style={{ marginBotton: '20px' }}>
            <Typography variant="body1" style={{ color: '#000000' }}>
              Datos del solicitante:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <StyledTextField name="name" label="Nombre" formik={formik} />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField name="phone" label="Teléfono" formik={formik} />
          </Grid>

          <Grid item xs={12}>
            <StyledTextField
              name="email"
              label="Dirección de correo"
              formik={formik}
            />
          </Grid>

          <Grid
            container
            justifyContent="space-between"
            style={{ margin: '20px auto' }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={() => closeModalHandler(false)}
              style={{
                borderRadius: '4px',
                backgroundColor: '#7E7E7E',
              }}
            >
              Cerrar
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              style={{ borderRadius: '4px' }}
            >
              Enviar
            </Button>
          </Grid>
        </form>
      </Grid>
    </>
  );
};

export default FormCheckAvailavility;
